module.exports = __webpack_public_path__ + "static/media/men-mem.264629ce.jpg";